<onyx-section
  [heading]="`${I18N}.heading.${category().includes('trailer') ? category() : 'vehicle'}`"
>
  <form [formGroup]="form()">
    @let controls = form().controls;
    <onyx-form-group [controls]="controls.curbWeight">
      <onyx-text-field
        data-testid="curb-weight-field"
        [formControl]="controls.curbWeight"
        [warning]="controls.curbWeight.value | unitWarning: 'vehicleWeight'"
        label="labels.curbWeight"
        [decimalPlaces]="0"
        unit="kg"
        [size]="32"
        [showErrors]="false"
      ></onyx-text-field>

      <onyx-suggestions
        [control]="controls.curbWeight"
        [suggestions]="
          controls.curbWeight.value | unitSuggestions: 'vehicleWeight'
        "
      ></onyx-suggestions>
    </onyx-form-group>

    @if (controls.axleCount.enabled) {
      <onyx-tabs
        data-testid="axle-count-tabs"
        [formControl]="controls.axleCount"
        [tabs]="axleCounts()"
        label="labels.axleCount"
        [fill]="true"
        [size]="32"
        width="100%"
      ></onyx-tabs>
    }

    @if (
      showLowDeck() && parametersForm().controls.isLowDeck;
      as lowDeckControl
    ) {
      <onyx-tabs
        data-testid="low-deck-tabs"
        [formControl]="lowDeckControl"
        [tabs]="LOW_DECK_OPTIONS"
        label="labels.type"
        [hint]="lowDeckHint"
        [fill]="true"
        [size]="32"
        width="100%"
        [onyxTooltip]="
          `forms.parameters.tooltips.lowDeck`
            | translate
              : {
                  size:
                    `${DictionaryCode.SEMI_TRAILER_SIZE}.${assignedSemiTrailerSize()}`
                    | translate,
                }
        "
        [onyxTooltipDisabled]="lowDeckControl.enabled"
      ></onyx-tabs>

      <ng-template #lowDeckHint>
        <p
          [innerHTML]="'forms.parameters.tooltips.lowDeckHint' | translate"
        ></p>
      </ng-template>
    }

    <onyx-form-group class="measurements" [controls]="controls.length">
      <onyx-text-field
        data-testid="length-field"
        [formControl]="controls.length"
        [warning]="controls.length.value | unitWarning: 'vehicleLength'"
        label="labels.length"
        [decimalPlaces]="2"
        unit="m"
        [size]="32"
        [showErrors]="false"
      ></onyx-text-field>

      <onyx-suggestions
        [control]="controls.length"
        [suggestions]="controls.length.value | unitSuggestions: 'vehicleLength'"
      ></onyx-suggestions>
    </onyx-form-group>

    <onyx-form-group [controls]="controls.width">
      <onyx-text-field
        data-testid="width-field"
        [formControl]="controls.width"
        [warning]="controls.width.value | unitWarning: 'vehicleWidth'"
        label="labels.width"
        [decimalPlaces]="2"
        unit="m"
        [size]="32"
        [showErrors]="false"
      ></onyx-text-field>

      <onyx-suggestions
        [control]="controls.width"
        [suggestions]="controls.width.value | unitSuggestions: 'vehicleWidth'"
      ></onyx-suggestions>
    </onyx-form-group>

    <onyx-form-group [controls]="controls.height">
      <onyx-text-field
        data-testid="height-field"
        [formControl]="controls.height"
        [warning]="controls.height.value | unitWarning: 'vehicleHeight'"
        label="labels.height"
        [decimalPlaces]="2"
        unit="m"
        [size]="32"
        [showErrors]="false"
      ></onyx-text-field>

      <onyx-suggestions
        [control]="controls.height"
        [suggestions]="controls.height.value | unitSuggestions: 'vehicleHeight'"
      ></onyx-suggestions>
    </onyx-form-group>
  </form>
</onyx-section>
